import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useLeaveTypes = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'leaveTypes',
    gqlEntityKey: 'leave_types',
    queryName: 'GET_LEAVE_TYPES_QUERY',
    createMutation: 'CREATE_LEAVE_TYPE_MUTATION',
    updateMutation: 'UPDATE_LEAVE_TYPE_MUTATION',
    deleteMutation: 'DELETE_LEAVE_TYPE_MUTATION',
    updateVariableName: 'set',
    transformData: (leaveType) => ({
      ...leaveType,
      company_name: leaveType.company?.name || `Company ${leaveType.company_id}`,
      leave_type_name: leaveType.leave_type_name,
      leave_type_description: leaveType.leave_type_description,
      leave_type_status: leaveType.leave_type_status ? 'active' : 'inactive',
      leave_type_days: leaveType.leave_type_days ?? null,
      leave_type_hours: leaveType.leave_type_hours ?? null,
      leave_type_deduct_from_annual_leave: leaveType.leave_type_deduct_from_annual_leave ?? false,
      companyId: leaveType.company_id,
    }),
    transformFormData: (formData) => ({
      leave_type_name: formData.leave_type_name,
      leave_type_description: formData.leave_type_description || null,
      leave_type_status: formData.leave_type_status === 'active',
      leave_type_days: formData.leave_type_days ? parseFloat(formData.leave_type_days) : null,
      leave_type_hours: formData.leave_type_hours ? parseFloat(formData.leave_type_hours) : null,
      leave_type_deduct_from_annual_leave: formData.leave_type_deduct_from_annual_leave === true || formData.leave_type_deduct_from_annual_leave === 'true',
      company_id: formData.companyId,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useLeaveTypes };
